import { PcrPayScale } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcrPayScale(id: number) {
  return restApiClient.url(constructApiUrl(API.pcrPayScale.update.url, { id })).get<PcrPayScale>()
}
